import { render, staticRenderFns } from "./RestaurantEditDialog.vue?vue&type=template&id=3ffa0599"
import script from "./RestaurantEditDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports